<template>
  <div class="flex">
    <slot></slot>
    <q-btn
      class="filter-icon q-ml-auto btn--no-hover"
      :class="{ active: showFilters }"
      icon="filter_alt"
      flat
      size="md"
      :ripple="false"
      @click="showFilters = !showFilters"
    >
      <q-tooltip>{{ showFilters ? 'Hide filters' : 'Show filters' }}</q-tooltip>
    </q-btn>
    <q-btn
      v-if="mode === 'read'"
      flat
      size="md"
      style="width: 30px"
      icon="edit"
      class="btn--no-hover"
      @click="goToRegistration($event)"
    >
      <q-tooltip>Edit ADF records</q-tooltip>
    </q-btn>
  </div>
  <div v-if="showFilters" class="row no-wrap full-width q-mt-sm q-mb-xs q-col-gutter-sm">
    <div v-if="$route.query?.adfRecordId" class="col">
      <q-input
        v-model="filters.id"
        label="ID"
        outlined
        dense
        clearable
        @update:model-value="filterTable()"
        class="q-mb-sm"
      ></q-input>
    </div>
    <div class="col">
      <q-select
        v-model="filters.status"
        :options="[
          { label: 'Completed', value: 'completed' },
          { label: 'In progress', value: 'inprogress' },
          { label: 'Failed', value: 'failed' },
          { label: 'Removed', value: 'removed' },
        ]"
        emit-value
        map-options
        options-dense
        @update:model-value="reloadTable()"
        label="Status"
        clearable
        outlined
        dense
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-select
        v-model="filters.provider"
        :options="['Azure', 'Swisscom']"
        options-dense
        label="Provider"
        outlined
        dense
        clearable
        @update:model-value="reloadTable()"
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-select
        v-model="filters.environment"
        :options="['DEV', 'NONPROD', 'PROD']"
        options-dense
        label="Environment"
        outlined
        dense
        clearable
        @update:model-value="reloadTable()"
        class="q-mb-sm"
      ></q-select>
    </div>
  </div>
  <AdfRecordsTable
    :registrationData="registrationData"
    ref="adfTable"
    @confirmDeleteAdfRecord="$emit('confirmDeleteAdfRecord', $event)"
    :rowsPerPageOptions="[5, 10, 15, 20]"
    :mode="mode"
    :filters="filters"
  >
    <template #expand> <slot name="expand"></slot></template>
  </AdfRecordsTable>
</template>

<script>
import emitter from 'tiny-emitter/instance';
import AdfRecordsTable from '@/shared/components/AdfRecordsTable.vue';
import { supportCntrlClick } from '@/shared/helpers';

export default {
  name: 'DnsWidget',
  components: {
    AdfRecordsTable,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
    mode: {
      type: String,
    },
  },
  data() {
    return {
      showFilters: false,
      timeout: undefined,
      filters: {
        id: undefined,
        registrationId: this.registrationId,
        digitalService: undefined,
        environment: undefined,
        provider: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    filterTable() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.reloadTable();
      }, 1500);
    },
    reloadTable() {
      this.$refs.adfTable.reload();
    },
    goToRegistration(event) {
      supportCntrlClick(
        event,
        `/my-portfolio/${this.registrationData.digitalServiceApm}/registration/${this.registrationId}`,
      );
    },
  },
  mounted() {
    if (this.$route.query?.adfRecordId) {
      this.showFilters = true;
      this.filters.id = this.$route.query?.adfRecordId;
    }
    this.reloadTable();
  },
  created() {
    emitter.on('reloadAdfRecords', () => {
      this.reloadTable();
    });
  },
  unmounted() {
    emitter.off('reloadAdfRecords');
  },
};
</script>
